<template lang='pug'>
  .edit-images
    .edit-image(v-for='image in images')
      .edit-image-thumbnail
        .edit-image-thumbnail-image
          img(:src='get_thumbnail(image.asset_public_id)')
      .edit-image-options
        .edit-image-copy
          | {{ image.asset_name }}
        el-button.edit-image-button(
          @click='digital_asset_modal=true'
          size='mini')
          | Replace
      .edit-image-buttons
        el-button(
          type='text'
          v-if="image.index > 0"
          @click='decrease_image_index(image, image.index)')
          i.pbxx-icon.pbxx-icon-long-arrow-up
        el-button(
          type='text'
          v-if="image.index < image_count - 1"
          @click='increase_image_index(image, image.index)')
          i.pbxx-icon.pbxx-icon-long-arrow-down
        el-button(
          type='text'
          @click='delete_image(image.index)')
          i.pbxx-icon.pbxx-icon-delete


    .edit-image(v-if="remaining_image_slots > 0")
      .edit-image-thumbnail
        .edit-image-thumbnail-placeholder
          i.pbxx-icon.pbxx-icon-crop-original
      .edit-image-options
        .edit-image-copy
          | Upload up to {{ remaining_image_slots }} {{ image_count === 0 ? '' : 'more' }} images {{ image_count === 0 ? 'to get started' : '' }}
        el-button.edit-image-button(
          @click='digital_asset_modal=true'
          size='mini')
          | Upload
        el-input(
          v-show='false'
          v-model='image_count'
          name="carousel"
          v-validate="'min_value: 2'"
          data-vv-as='carousel'
        )
        .error(v-if='errors.has(widget.id)')
          span
            | The carousel must have at least two images

    el-dialog(title='Select Assets', :visible.sync='digital_asset_modal', width='60%', center, :append-to-body='true')
      digital_asset_uploader(
        :associable_endpoint='get_associable_endpoint'
        :authorization='get_authorization'
        :multiple='true'
        :accept='resource_types'
        :show_input='false'
        :replace='true'
        :digital_asset_params='{}'
        :empty_uploader='false'
        :action_endpoint='cloudinary_endpoint'
        @upload_progress='on_upload_progress'
        @upload_success='on_upload_success'
        @digital_asset_created='on_digital_asset_created')
      .edit-campaign_assets(v-if='digital_asset_collection.length')
        p.edit-campaign_assets-title
          | Or choose an existing image
        digital_asset_gallery.edit-campaign_assets-selector.has_selected_cards(
          ref='gallery'
          :digital_assets='digital_asset_collection'
          slot='gallery'
          @digital_asset_select_click='on_digital_asset_select_toggled'
          @digital_asset_card_click='on_digital_asset_select_toggled')
      span(
        slot='footer'
        class='dialog-footer')
        el-button(
          type='primary'
          @click='select_asset')
          | {{this.widget.draft_content.asset_public_id ? 'Update' : 'Select'}}
      span.error(v-if='show_modal_error')
        | You may only select up to {{ this.widget.draft_content.image_limit }} images per carousel widget.
</template>

<script>
  import _ from 'lodash'
  import Cookies from 'js-cookie'
  import { db, config_obj } from '../utils/firebase'
  import cloudinary_initializer from '../mixins/cloudinary_initializer'

  export default {
    name: 'carousel_edit',
    mixins: [
      cloudinary_initializer
    ],
    inject: {
      $validator: '$validator'
    },
    props: {
      landing_page_widget: {
        type: Object,
        required: true
      },
      campaign_id: {
        type: String,
        required: true
      },
      brand_id: {
        type: String,
        required: true
      },
      accepted_resource_types: {
        type: String,
        default: 'image/*'
      },
    },
    data() {
      return {
        resource_types: this.accepted_resource_types,
        digital_asset_modal: false,
        cropping_modal: false,
        digital_asset_collection: [],
        digital_assets: [],
        selected_digital_assets: [],
        widget: this.landing_page_widget,
        selected_digital_asset: false,
        show_modal_error: false
      }
    },
    async created() {
      const asset_collection = await db.collection(`brands/${this.brand_id}/campaigns/${this.campaign_id}/digital_assets`).get()
      const asset_array = []
      asset_collection.forEach(asset => asset_array.push(asset.data()))
      this.digital_assets = asset_array
    },
    watch: {
      digital_assets(vals) {
        const media_type = 'image'
        const filtered_assets = vals.filter(asset => {
          if(!asset.file && asset.upload_percentage < 100){
            return true
          }
          return asset.resource_type === 'image' ? true: false
        })
        const saved_asset_id = this.widget.draft_content.asset_public_id

        this.digital_asset_collection = filtered_assets.map(digital_asset=> {
          const asset_id = digital_asset.file ? digital_asset.file.public_id : null
          saved_asset_id === asset_id ? this.$set(digital_asset, 'is_selected', true) : this.$set(digital_asset, 'is_selected', false)
          return digital_asset
        })
      }
    },
    computed: {
      get_authorization() {
        return Cookies.get('token')
      },
      get_associable_endpoint() {
        return `${config_obj.api_base_path}/v2/campaigns/${this.campaign_id}`
      },
      images() {
        return _.orderBy(this.widget.draft_content.images, 'index', 'asc') 
      },
      image_count() {
        return this.images.length
      },
      remaining_image_slots() {
        return this.widget.draft_content.image_limit - this.image_count
      },

      image_url(id) {
        return this.cl.url(id, {
          dpr: 'auto',
          fetch_format: 'auto',
          quality: 'auto',
          crop: 'crop',
          client_hints: true
        })
      },
      asset_name() {
        return this.widget.draft_content.asset_name
      },
      cloud_name() {
        return config_obj.cloudinary_cloud_name
      },
      cloudinary_endpoint() {
        return `https://api.cloudinary.com/v1_1/${this.cloud_name}/upload`
      },
      get_error_message() {
        // TODO: Figure out a better way to do this
        let error_message = this.errors.first(this.landing_page_widget.id)
        error_message = error_message.replace('+ text', '')
        error_message = error_message.replace('hero', 'image')
        return error_message
      }
    },
    methods: {
      get_thumbnail(id) {
        return this.cl.url(id, {
          width: '52',
          height: '52',
          dpr: 'auto',
          fetch_format: 'auto',
          quality: 'auto',
          crop: 'thumb',
          client_hints: true
        })
      },
      decrease_image_index(image, index) {
        let images = this.images
        const switched_image = _.find(images, image => image.index === index - 1)
        

        image.index = index - 1
        switched_image.index = index

        images = _.filter(images, image => image.index !== index && image.index !== index - 1)

        images.push(image, switched_image)
        this.change(images, 'images')
      },
      increase_image_index(image, index) {
        let images = this.images
        const switched_image = _.find(images, image => image.index === index + 1)
        

        image.index = index + 1
        switched_image.index = index

        images = _.filter(images, image => image.index !== index && image.index !== index + 1)

        images.push(image, switched_image)
        this.change(images, 'images')
      },
      delete_image(index) {
        let images = this.images
        images = _.filter(images, image => image.index !== index)
        images.forEach(image => {
          if (image.index > index) {
            image.index = image.index - 1
          }
        })
        this.change(images, 'images')
      },
      change(val, key) {
        this.landing_page_widget.draft_content[key] = val
        this.$emit('input', this.landing_page_widget)
      },
      on_digital_asset_created(digital_asset) {
        this.digital_assets.unshift(digital_asset)
      },
      on_upload_progress(event, file) {
        let digital_asset = this.find_digital_asset_from_file(file)
        digital_asset.upload_percentage = Math.floor(event.percent)
      },
      on_upload_success(event, file) {
        let digital_asset = this.find_digital_asset_from_file(file)
        digital_asset.file = file.response
      },
      on_digital_asset_select_toggled(digital_asset, index) {
        this.show_modal_error = false
        digital_asset.is_selected = !digital_asset.is_selected
        if (digital_asset.is_selected) {
          this.selected_digital_assets.push(digital_asset)
        } else {
          this.selected_digital_assets = _.filter(this.selected_digital_assets, asset => asset.id !== digital_asset.id)
        }
      },
      find_digital_asset_from_file(file) {
        return this.digital_assets.find(da => {
          return da.name === `${file.name}`
        })
      },
      select_asset() {
        if(this.selected_digital_assets.length > this.widget.draft_content.image_limit) {
          this.show_modal_error = true
          return
        }

        let images = []

        for(let i = 0; i < this.selected_digital_assets.length; i++) {
          const asset = this.selected_digital_assets[i]
          images.push({
            alt_text: '',
            asset_name: asset.name,
            asset_public_id: asset.file.public_id,
            caption: '',
            index: i
          })
        }
        this.change(images, 'images')
        this.digital_asset_modal = false
      }
    }
  }
</script>

<style lang='scss'>
  // Override for elementUI
  .digital-asset-uploader {
    .el-upload.el-upload--text {
      width: 100%;
      .el-upload-dragger {
        border: none;
      }
    }
  }
</style>

<style lang='scss' scoped>
  .edit {
    @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
    padding: 20px;
    &-header {
      margin-bottom: 30px;
    }
    &-close,
    &-title {
      display: inline-block;
      text-align: center;
    }
    &-close {
      width: 5%;
    }
    &-title {
      width: 95%;
      text-transform: capitalize;
    }
    &-setting {
      margin-bottom: 20px;
      width: 100%;
      &-label {
        text-transform: capitalize;
        display: block;
      }
    }
    &-image {
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 1px solid get-color(gray-lightest);
      position: relative;
      &-buttons {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
        button {
          padding: .5em 5px;
          color: get-color(gray);
          &:hover {
            color: get-color(gray-dark);
          }
        }
      }
      &-setting {
        margin-top: 20px;
        label {
          width: 100%;
        }
      }
      &-thumbnail,
      &-options {
        display: inline-block;
        vertical-align: top;
        .error {
          color: red;
        }
      }
      &-options {
        max-width: 80%;
      }
      &-options {
        margin-left: 15px;
      }
      &-thumbnail {
        height: 52px;
        width: 52px;
        margin-right: 15px;
        &-image {
        }
        &-placeholder {
          text-align: center;
          color: get-color(gray);
          background: get-color(gray-lightest);
          height: 100%;
          font-size: 36px;
        }
      }
      &-copy {
        font-size: 12px;
        margin-bottom: 4px;
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &-campaign_assets {
      border-top: 1px solid get-color(gray-lightest);
      &-title {
        color: get-color(gray-darkest);
        text-align: center;
        margin: 20px 0 0;
      }
      &-selector {
        height: 20vh;
        min-height: 150px;
        display: block;
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }

  // force scroll bar for digital assets in modal
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,200,.5);
  }
</style>
